import { actionTypes as impersonateActions } from '~/store/impersonate';
import { actionTypes as cartActions } from '~/store/cart';

export default function ({ store }) {
    store.dispatch(cartActions.LOAD_FROM_STORAGE);
    store.dispatch(impersonateActions.LOAD_FROM_STORAGE);
}
